module.exports = window["google"];